import { isJoJoReadBrowser } from './index';
/**
 * 获取是不是叫叫app小窗环境
 * @returns boolean
 */

export var getIsWindowModel = function getIsWindowModel() {
  if (isJoJoReadBrowser()) {
    var ua = window.navigator.userAgent.toLowerCase();
    return /jojowindowtype\/window/i.test(ua);
  }

  return false;
};